/**
 * Full icon registry — the default `getIcon`/`requestFullIconRegistry`/`useIconRegistryVersion`
 * implementation, used by the SPA, the SSR server, the B2B tenant client, and every test. It
 * statically inlines the complete `Icons.json` (642 icons): none of those targets route-split, so
 * there is nothing to lazily fetch icons against — every icon has to be available synchronously.
 *
 * The marketing client is the one exception: `iconRegistry.marketing.ts` is swapped in for this
 * file (import specifier `"./iconRegistry"` from `Icon.tsx`) by the plugin in `vite.config.ssr.ts`
 * when `SSR_TARGET=client-marketing`, so it can ship only a small core icon set up front.
 */
import Icons from "./Icons.json";

export const IS_PARTIAL_ICON_REGISTRY = false;

export function getIcon(name: string): any {
	return (Icons as any)[name];
}

// No-op here — this registry is already complete. Only the marketing registry has a "rest of the
// icons" to go fetch.
export function requestFullIconRegistry(): void {}

// The full registry never changes after load, so there is never a second version to render.
export function useIconRegistryVersion(): number {
	return 0;
}
